import jr_chuosobu_local from '../assets/images/stations/transfers/jr_chuosobu_local.svg'
import jr_joban_rapid from '../assets/images/stations/transfers/jr_joban_rapid.svg'
import jr_keihintohoku from '../assets/images/stations/transfers/jr_keihintohoku.svg'
import jr_musashino from '../assets/images/stations/transfers/jr_musashino.svg'
import jr_yamanote from '../assets/images/stations/transfers/jr_yamanote.svg'
import metro_chiyoda from '../assets/images/stations/transfers/metro_chiyoda.svg'
import metro_hibiya from '../assets/images/stations/transfers/metro_hibiya.svg'
import tobu_skytree from '../assets/images/stations/transfers/tobu_skytree.svg'
import tobu_urbanpark from '../assets/images/stations/transfers/tobu_urbanpark.svg'
import toei_oedo from '../assets/images/stations/transfers/toei_oedo.svg'
import toei_shinjuku from '../assets/images/stations/transfers/toei_shinjuku.svg'

export const stationsMaster = [
  {
    number: '01',
    name: '秋葉原',
    furigana: 'あきはばら',
    stationId: 11,
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: null,
        holidays: null
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=3494&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=3494&line=1&target=holiday&direction=1&webview=on'
      }
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/akihabara/?exbrowser=1',
    stationLayoutPath: '/station_layout/01_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=3494&webview=on',
    transferLines: [
      {
        companyName: 'JR東日本',
        appStoreUrl: 'https://itunes.apple.com/jp/app/apple-store/id820004378?pt=641888&ct=txapp&mt=8',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=jp.co.jreast&referrer=utm_source%3Dtxapp',
        lines: [
          {
            name: 'JR山手線',
            nameTransferLine: '山手線',
            icon: jr_yamanote,
            timeTableUrlFromTrains: 'jreast-app://?vid=C603-0001&kid=6013-0001&at4=0041',
            timeTableUrlFromStation: 'jreast-app://?vid=C602-0001&kid=6013-0001&at4=0041',
          },
          {
            name: 'JR中央・総武線各駅停車',
            nameTransferLine: '中央・総武線各駅停車',
            icon: jr_chuosobu_local,
            timeTableUrlFromTrains: 'jreast-app://?vid=C601-0001&kid=6013-0001&at4=0041&line=56&lineCode=56',
            timeTableUrlFromStation: 'jreast-app://?vid=C602-0001&kid=6013-0001&at4=0041',
          },
          {
            name: 'JR京浜東北線',
            nameTransferLine: '京浜東北線',
            icon: jr_keihintohoku,
            timeTableUrlFromTrains: 'jreast-app://?vid=C601-0001&kid=6013-0001&at4=0041&line=40&lineCode=40',
            timeTableUrlFromStation: 'jreast-app://?vid=C602-0001&kid=6013-0001&at4=0041',
          }
        ]
      },
      {
        companyName: '東京メトロ',
        appStoreUrl: 'https://apps.apple.com/app/apple-store/id439646577?pt=567246&ct=tx-app&mt=8',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.tokyometro&referrer=utm_source%3Dtx-app',
        lines: [
          {
            name: '東京メトロ日比谷線',
            nameTransferLine: '日比谷線',
            icon: metro_hibiya,
            timeTableUrlFromTrains: 'metroapp://?contentsId=trainLocation&sourceAppId=txapp&useUserStation=0&stationId=odpt.Station:TokyoMetro.Hibiya.Akihabara',
            timeTableUrlFromStation: 'metroapp://?contentsId=stationTimetable&sourceAppId=txapp&useUserStation=0&stationId=odpt.Station:TokyoMetro.Hibiya.Akihabara'
          },
        ]
      },
      {
        companyName: '東京都交通局',
        appStoreUrl: 'https://apps.apple.com/app/apple-store/id1499614655?pt=121085394&ct=tx&mt=8',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=jp.tokyo.metro.kotsu.toei.naviapp&referrer=utm_source%3Dtx',
        lines: [
          {
            name: '都営新宿線(岩本町駅)',
            nameTransferLine: '都営新宿線(岩本町駅)',
            icon: toei_shinjuku,
            timeTableUrlFromTrains: 'toeiapp://trainlocation?line_id=3&station_id=1443&from=tx',
            timeTableUrlFromStation: 'toeiapp://timetable?station_id=1443&from=tx'
          }
        ]
      }
    ]
  },
  {
    number: '02',
    name: '新御徒町',
    stationId: 12,
    furigana: 'しんおかちまち',
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9216&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9216&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9216&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9216&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/shin-okachimachi/?exbrowser=1',
    stationLayoutPath: '/station_layout/02_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9216&webview=on',
    transferLines: [
      {
        companyName: '東京都交通局',
        appStoreUrl: 'https://apps.apple.com/app/apple-store/id1499614655?pt=121085394&ct=tx&mt=8',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=jp.tokyo.metro.kotsu.toei.naviapp&referrer=utm_source%3Dtx',
        lines: [
          {
            name: '都営大江戸線',
            nameTransferLine: '大江戸線',
            icon: toei_oedo,
            timeTableUrlFromTrains: 'toeiapp://trainlocation?line_id=1&station_id=9216&from=tx',
            timeTableUrlFromStation: 'toeiapp://timetable?station_id=9216&from=tx'
          }
        ]
      },
    ]
  },
  {
    number: '03',
    name: '浅草',
    furigana: 'あさくさ',
    stationId: 13,
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9444&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9444&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9444&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9444&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/asakusa/?exbrowser=1',
    stationLayoutPath: '/station_layout/03_jp.jpg',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9444&webview=on'
  },
  {
    number: '04',
    name: '南千住',
    furigana: 'みなみせんじゅ',
    stationId: 14,
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9445&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9445&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9445&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9445&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/minami-senju/?exbrowser=1',
    stationLayoutPath: '/station_layout/04_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9445&webview=on',
    transferLines: [
      {
        companyName: 'JR東日本',
        appStoreUrl: 'https://itunes.apple.com/jp/app/apple-store/id820004378?pt=641888&ct=txapp&mt=8',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=jp.co.jreast&referrer=utm_source%3Dtxapp',
        lines: [
          {
            name: 'JR常磐線快速電車/常磐線',
            nameTransferLine: '常磐線快速電車/常磐線',
            icon: jr_joban_rapid,
            timeTableUrlFromTrains: 'jreast-app://?vid=C601-0001&kid=6013-0001&at4=1487&line=47&lineCode=47',
            timeTableUrlFromStation: 'jreast-app://?vid=C602-0001&kid=6013-0001&at4=1487',
          }
        ]
      },
      {
        companyName: '東京メトロ',
        appStoreUrl: 'https://apps.apple.com/app/apple-store/id439646577?pt=567246&ct=tx-app&mt=8',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.tokyometro&referrer=utm_source%3Dtx-app',
        lines: [
          {
            name: '東京メトロ日比谷線',
            nameTransferLine: '日比谷線',
            icon: metro_hibiya,
            timeTableUrlFromTrains: 'metroapp://?contentsId=trainLocation&sourceAppId=txapp&useUserStation=0&stationId=odpt.Station:TokyoMetro.Hibiya.MinamiSenju',
            timeTableUrlFromStation: 'metroapp://?contentsId=stationTimetable&sourceAppId=txapp&useUserStation=0&stationId=odpt.Station:TokyoMetro.Hibiya.MinamiSenju'
          },
        ]
      }
    ]
  },
  {
    number: '05',
    name: '北千住',
    furigana: 'きたせんじゅ',
    stationId: 15,
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=8355&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=8355&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=8355&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=8355&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/kita-senju/?exbrowser=1',
    stationLayoutPath: '/station_layout/05_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=8355&webview=on',
    transferLines: [
      {
        companyName: 'JR東日本',
        appStoreUrl: 'https://itunes.apple.com/jp/app/apple-store/id820004378?pt=641888&ct=txapp&mt=8',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=jp.co.jreast&referrer=utm_source%3Dtxapp',
        lines: [
          {
            name: 'JR常磐線快速電車/常磐線',
            nameTransferLine: '常磐線快速電車/常磐線',
            icon: jr_joban_rapid,
            timeTableUrlFromTrains: 'jreast-app://?vid=C601-0001&kid=6013-0001&at4=0571&line=47&lineCode=47',
            timeTableUrlFromStation: 'jreast-app://?vid=C602-0001&kid=6013-0001&at4=0571',
          }
        ]
      },
      {
        companyName: '東武鉄道',
        appStoreUrl: 'https://apps.apple.com/jp/app/tobu-point-%E6%9D%B1%E6%AD%A6%E3%82%B0%E3%83%AB%E3%83%BC%E3%83%97%E5%85%B1%E9%80%9A%E3%83%9D%E3%82%A4%E3%83%B3%E3%83%88-%E3%83%88%E3%83%96%E3%83%9D/id1523037099',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=jp.co.tobu.tobupointapp&hl=ja',
        lines: [
          {
            name: '東武スカイツリーライン',
            nameTransferLine: 'スカイツリーライン',
            icon: tobu_skytree,
            timeTableUrlFromTrains: 'tobulineapp://?f=1&l=1&s=TS09&k=tsukubaexapp',
          },
        ]
      },
      {
        companyName: '東京メトロ',
        appStoreUrl: 'https://apps.apple.com/app/apple-store/id439646577?pt=567246&ct=tx-app&mt=8',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.tokyometro&referrer=utm_source%3Dtx-app',
        lines: [
          {
            name: '東京メトロ千代田線',
            nameTransferLine: '千代田線',
            icon: metro_chiyoda,
            timeTableUrlFromTrains: 'metroapp://?contentsId=trainLocation&sourceAppId=txapp&useUserStation=0&stationId=odpt.Station:TokyoMetro.Chiyoda.KitaSenju',
            timeTableUrlFromStation: 'metroapp://?contentsId=stationTimetable&sourceAppId=txapp&useUserStation=0&stationId=odpt.Station:TokyoMetro.Chiyoda.KitaSenju'
          },
          {
            name: '東京メトロ日比谷線',
            nameTransferLine: '日比谷線',
            icon: metro_hibiya,
            timeTableUrlFromTrains: 'metroapp://?contentsId=trainLocation&sourceAppId=txapp&useUserStation=0&stationId=odpt.Station:TokyoMetro.Hibiya.KitaSenju',
            timeTableUrlFromStation: 'metroapp://?contentsId=stationTimetable&sourceAppId=txapp&useUserStation=0&stationId=odpt.Station:TokyoMetro.Hibiya.KitaSenju'
          },
        ]
      }
    ]
  },
  {
    number: '06',
    name: '青井',
    furigana: 'あおい',
    stationId: 16,
    stopTypes: ['local'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9443&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9443&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9443&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9443&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/aoi/?exbrowser=1',
    stationLayoutPath: '/station_layout/06_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9443&webview=on'
  },
  {
    number: '07',
    name: '六町',
    furigana: 'ろくちょう',
    stationId: 17,
    stopTypes: ['local', 'semi_r', 'com_r'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9452&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9452&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9452&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9452&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/rokucho/?exbrowser=1',
    stationLayoutPath: '/station_layout/07_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9452&webview=on'
  },
  {
    number: '08',
    name: '八潮',
    furigana: 'やしお',
    stationId: 18,
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9448&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9448&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9448&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9448&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/yashio/?exbrowser=1',
    stationLayoutPath: '/station_layout/08_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9448&webview=on'
  },
  {
    number: '09',
    name: '三郷中央',
    furigana: 'みさとちゅうおう',
    stationId: 19,
    stopTypes: ['local', 'semi_r'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9442&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9442&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9442&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9442&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/misato-chuo/?exbrowser=1',
    stationLayoutPath: '/station_layout/09_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9442&webview=on'
  },
  {
    number: '10',
    name: '南流山',
    furigana: 'みなみながれやま',
    stationId: 20,
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=7177&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=7177&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=7177&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=7177&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/minami-nagareyama/?exbrowser=1',
    stationLayoutPath: '/station_layout/10_jp.jpg',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=7177&webview=on',
    transferLines: [
      {
        companyName: 'JR東日本',
        appStoreUrl: 'https://itunes.apple.com/jp/app/apple-store/id820004378?pt=641888&ct=txapp&mt=8',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=jp.co.jreast&referrer=utm_source%3Dtxapp',
        lines: [
          {
            name: 'JR武蔵野線（東京～府中本町）',
            nameTransferLine: '武蔵野線（東京～府中本町）',
            icon: jr_musashino,
            timeTableUrlFromTrains: 'jreast-app://?vid=C601-0001&kid=6013-0001&at4=1495&line=67-1&lineCode=67-1',
            timeTableUrlFromStation: 'jreast-app://?vid=C602-0001&kid=6013-0001&at4=1495',
          },
          {
            name: 'JR武蔵野線（海浜幕張～府中本町）',
            nameTransferLine: '武蔵野線（海浜幕張～府中本町）',
            icon: jr_musashino,
            timeTableUrlFromTrains: 'jreast-app://?vid=C601-0001&kid=6013-0001&at4=1495&line=67-2&lineCode=67-2',
            timeTableUrlFromStation: 'jreast-app://?vid=C602-0001&kid=6013-0001&at4=1495',
          }
        ]
      }
    ]
  },
  {
    number: '11',
    name: '流山セントラルパーク',
    furigana: 'ながれやまセントラルパーク',
    stationId: 21,
    stopTypes: ['local'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9451&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9451&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9451&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9451&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/nagareyama-centralpark/?exbrowser=1',
    stationLayoutPath: '/station_layout/11_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9451&webview=on'
  },
  {
    number: '12',
    name: '流山おおたかの森',
    furigana: 'ながれやまおおたかのもり',
    stationId: 22,
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9450&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9450&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9450&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9450&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/nagareyama-otakanomori/?exbrowser=1',
    stationLayoutPath: '/station_layout/12_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9450&webview=on',
    transferLines: [
      {
        companyName: '東武鉄道',
        appStoreUrl: 'https://apps.apple.com/jp/app/tobu-point-%E6%9D%B1%E6%AD%A6%E3%82%B0%E3%83%AB%E3%83%BC%E3%83%97%E5%85%B1%E9%80%9A%E3%83%9D%E3%82%A4%E3%83%B3%E3%83%88-%E3%83%88%E3%83%96%E3%83%9D/id1523037099',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=jp.co.tobu.tobupointapp&hl=ja',
        lines: [
          {
            name: '東武アーバンパークライン',
            nameTransferLine: 'アーバンパークライン',
            icon: tobu_urbanpark,
            timeTableUrlFromTrains: 'tobulineapp://?f=1&l=8&s=TD22&k=tsukubaexapp',
          }
        ]
      }
    ]
  },
  {
    number: '13',
    name: '柏の葉キャンパス',
    furigana: 'かしわのはキャンパス',
    stationId: 23,
    stopTypes: ['local', 'semi_r', 'com_r'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9447&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9447&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9447&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9447&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/kashiwanoha-campus/?exbrowser=1',
    stationLayoutPath: '/station_layout/13_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9447&webview=on'
  },
  {
    number: '14',
    name: '柏たなか',
    furigana: 'かしわたなか',
    stationId: 24,
    stopTypes: ['local'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9446&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9446&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9446&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9446&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/kashiwa-tanaka/?exbrowser=1',
    stationLayoutPath: '/station_layout/14_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9446&webview=on'
  },
  {
    number: '15',
    name: '守谷',
    furigana: 'もりや',
    stationId: 25,
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=3450&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=3450&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=3450&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=3450&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/moriya/?exbrowser=1',
    stationLayoutPath: '/station_layout/15_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=3450&webview=on',
    transferLines: [
      {
        companyName: '関東鉄道',
        lines: [
          {
            name: '関東鉄道常総線',
            nameTransferLine: '常総線',
          }
        ]
      }
    ]
  },
  {
    number: '16',
    name: 'みらい平',
    furigana: 'みらいだいら',
    stationId: 26,
    stopTypes: ['local', 'semi_r'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9440&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9440&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9440&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9440&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/miraidaira/?exbrowser=1',
    stationLayoutPath: '/station_layout/16_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9440&webview=on'
  },
  {
    number: '17',
    name: 'みどりの',
    furigana: 'みどりの',
    stationId: 27,
    stopTypes: ['local', 'semi_r'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9439&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9439&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9439&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9439&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/midorino/?exbrowser=1',
    stationLayoutPath: '/station_layout/17_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9439&webview=on'
  },
  {
    number: '18',
    name: '万博記念公園',
    furigana: 'ばんぱくきねんこうえん',
    stationId: 28,
    stopTypes: ['local', 'semi_r'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9449&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9449&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9449&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9449&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/bampaku-kinenkoen/?exbrowser=1',
    stationLayoutPath: '/station_layout/18_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9449&webview=on'
  },
  {
    number: '19',
    name: '研究学園',
    furigana: 'けんきゅうがくえん',
    stationId: 29,
    stopTypes: ['local', 'semi_r', 'com_r'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9441&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9441&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9441&line=1&target=weekday&direction=1&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9441&line=1&target=holiday&direction=1&webview=on'
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/kenkyu-gakuen/?exbrowser=1',
    stationLayoutPath: '/station_layout/19_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9441&webview=on'
  },
  {
    number: '20',
    name: 'つくば',
    furigana: 'つくば',
    stationId: 30,
    stopTypes: ['local', 'semi_r', 'com_r', 'rapid'],
    trains: {
      up: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
      down: {
        bant: {
          honors: [],
          local: []
        },
        sift: {
          honors: [],
          local: []
        }
      },
    },
    timeTables: {
      up: {
        weekdays: 'https://transfer-train.navitime.biz/tx/timetable?station=9438&line=1&target=weekday&direction=0&webview=on',
        holidays: 'https://transfer-train.navitime.biz/tx/timetable?station=9438&line=1&target=holiday&direction=0&webview=on'
      },
      down: {
        weekdays: null,
        holidays: null
      },
    },
    officialSiteLink: 'https://www.mir.co.jp/route_map/tsukuba/?exbrowser=1',
    stationLayoutPath: '/station_layout/20_jp.png',
    fareTableUrl: 'https://transfer-train.navitime.biz/tx/fare?station=9438&webview=on'
  }
];
